import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

/**
 * GET /api/v1/processed-order/by-shopify-auth-url?s=...
 * @param {string} shopifyAuthUrl — full Shopify authenticate URL (encoded as query param)
 * @returns {Promise<unknown>}
 */
export const getProcessedOrderByShopifyAuthUrl = async (shopifyAuthUrl) => {
  const s = String(shopifyAuthUrl ?? "").trim();
  if (!s) {
    const err = new Error("Missing Shopify auth URL");
    return Promise.reject(err);
  }

  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(
    "/api/v1/processed-order/by-shopify-auth-url",
    { params: { s } },
  );
  return data;
};
